import React from "react";
import { Form, Col, Row } from "react-bootstrap";
import { CustomSelect } from "../../../../../../_helpers/Helpers";

export function PersonnelPartnerInfoForm({
  partner,
  handleChange,
  values
 }) {
  return (
    <>
      <Form.Group as={Row} controlId="partner.tcKimlikNo">
        <Form.Label column sm={2}>
          TC Kimlik No
        </Form.Label>
        <Col sm={6}>
          <Form.Control type="text" value={values.tcKimlikNo} placeholder="TC Kimlik No" onChange={handleChange} />
        </Col>
      </Form.Group>
                    
      <Form.Group as={Row} controlId="partner.name">
        <Form.Label column sm={2}>
          Adı
        </Form.Label>
        <Col sm={6}>
          <Form.Control type="text" value={values.name} placeholder="Adı" onChange={handleChange} />
        </Col>
      </Form.Group>
                    
      <Form.Group as={Row} controlId="partner.surname">
        <Form.Label column sm={2}>
          Soyadı
        </Form.Label>
        <Col sm={6}>
          <Form.Control type="text" value={values.surname} placeholder="Soyadı" onChange={handleChange} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="partner.occupationCategory">
        <Form.Label column sm={2}>
          Meslek Kategorisi
        </Form.Label>
        <Col sm={6}>
          <CustomSelect
            options={partner.occupationCategories}
            value={values.occupationCategoryId}
            onChange={option => handleChange("partner.occupationCategoryId")(option.value)}
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="partner.occupation">
        <Form.Label column sm={2}>
          Mesleği
        </Form.Label>
        <Col sm={6}>
          <Form.Control type="text" value={values.occupation} placeholder="Mesleği" onChange={handleChange} />
        </Col>
      </Form.Group>
    </>        
  );
}